
import { Component, Vue, Prop } from 'vue-property-decorator';
import { technologistOrderFormConfiguration } from '@/helpers/OrderHelper';
import { getDatepickerLocale } from '@/helpers/LocaleHelper';
import NextStep from '@/models/NextStep';
import { TechnologistFormField } from '@/interfaces/components/projectNew/TechnologistFormField';

@Component({
    name: 'TechnologistOrderFormDates',
    components: {},
})
export default class TechnologistOrderFormDates extends Vue {
    @Prop({ required: true }) private value!: any;
    @Prop({ required: true }) private errors!: any;

    private get orderFormConfiguration() {
        return technologistOrderFormConfiguration;
    }

    private get dateFormFields(): TechnologistFormField[] {
        return this.orderFormConfiguration.formFields.filter((field) => field.type === 'date');
    }

    private get locale() {
        return getDatepickerLocale();
    }

    private get workFreeDays(): any[] {
        return this.$store.getters['tableData/workFreeDays'] ?? [];
    }

    private async mounted() {
        if (this.workFreeDays.length) {
            return;
        }
        try {
            await NextStep.getWorkFreeDays();
        } catch (e) {
            // The picker still enforces the 3 week minimum without holidays.
        }
    }

    private getDisabledDate(field: TechnologistFormField) {
        if (field.name !== 'deliveryDate') {
            return undefined;
        }
        return () => false;
    }

    private onFormChange(field: TechnologistFormField) {
        this.$emit('input', { ...this.value });
        if (!this.errors[field.name]) {
            return;
        }
        this.$emit('validateField', field.name);
    }
}
